import { Getter, ItemMenu, ItemMenuConfig, Params } from './menu.types';

export const itensMenuConfig: ItemMenuConfig[] = [
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'home',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'disciplinas',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'biblioteca-virtual',
    habilitado: true,
  },
  {
    marcas: ['ibmec'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'biblioteca-virtual',
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'biblioteca-virtual',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'empregabilidade',
    habilitado: true,
  },
  {
    marcas: ['idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO'],
    item: 'empregabilidade',
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'empregabilidade',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'calendario-academico',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'ajuda',
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'ajuda',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'ibmec', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'exercicios',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'avaliacoes',
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'avaliacoes',
    habilitado: true,
  },
  {
    marcas: ['ibmec'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['ESPECIALIZAÇÃO'],
    item: 'avaliacoes',
    modalidade: ['TOTAL EAD'],
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['ESPECIALIZAÇÃO'],
    item: 'avaliacoes',
    modalidade: ['AO VIVO'],
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'campus-sia',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'secretaria-digital',
    habilitado: true,
  },
  {
    marcas: ['idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['ESPECIALIZAÇÃO'],
    item: 'avaliacoes',
    modalidade: [
      'TOTAL EAD',
      'EAD',
      'FLEX',
      'FLEX ESPECIAL',
      'SEMIPRESENCIAL',
      'PRESENCIAL',
      'AO VIVO',
      'TELEPRESENCIAL',
    ],
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['ESPECIALIZAÇÃO'],
    item: 'avaliacoes',
    modalidade: ['TOTAL EAD', 'EAD', 'FLEX', 'FLEX ESPECIAL', 'SEMIPRESENCIAL', 'PRESENCIAL', 'TELEPRESENCIAL'],
    habilitado: true,
  },
  {
    marcas: ['estacio'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'campus-sia',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'acessibilidade',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'certificacoes',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'cursos-complementares',
    habilitado: true,
  },
  {
    marcas: ['ibmec'],
    ambientes: ['local', 'dev', 'hml', 'prd'],
    tipoCurso: ['ESPECIALIZAÇÃO'],
    modalidade: ['PRESENCIAL'],
    item: 'cursos-complementares',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden'],
    ambientes: ['local', 'dev', 'hml', 'prd'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'suporte-aos-estudos',
    habilitado: true,
  },

  // itens do menu V2 - config específica para cada subitem
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'formacao-socioemocional',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'mapeamento-socioemocional',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'area-estagio',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'portal-carreiras',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'minha-biblioteca',
    habilitado: false,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'pergamum',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'dynamed',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'ficha-catalografica',
    habilitado: true,
  },
  {
    marcas: ['idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA'],
    item: 'clinicalkey',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO', 'FORMAÇÃO PROFISSIONAL NÍVEL TÉCNICO'],
    item: 'apresentacao-plataforma',
    habilitado: true,
  },
  {
    marcas: ['estacio', 'ibmec', 'wyden', 'idomed'],
    ambientes: ['local', 'dev', 'prd', 'hml'],
    tipoCurso: ['GRADUAÇÃO', 'GRADUAÇÃO TECNOLÓGICA', 'ESPECIALIZAÇÃO'],
    item: 'renova',
    habilitado: true,
  },
];

export const getItensMenuConfig: Getter<Params, ItemMenu[]> = ({ ambiente, marca }: Params) => {
  return itensMenuConfig
    .filter((item) => item.marcas.includes(marca) && item.ambientes.includes(ambiente) && item.habilitado)
    .map((item) => ({
      item: item.item,
      tipoCursoAluno: item.tipoCurso,
      modalidadeAluno: item.modalidade,
    }));
};
